/**
 * Mapeamento canônico, unificação de apelidos e regras de busca de bairros de Artur Nogueira.
 *
 * Garante que:
 * 1. Nomes duplicados ou variações populares da mesma área sejam unificados
 *    (ex: 'Bairrinha' e 'Bairrinho', 'Jardim de Faveri' e 'Jardim Faveri').
 * 2. Fases e numerações distintas (ex: 'Jardim Sacilotto I' e 'Jardim Sacilotto II')
 *    sejam preservadas como bairros independentes e nunca colidam por substring.
 *
 * @module constants/neighborhoods
 */

export const CANONICAL_BAIRRO_MAP = {
  "agostinho delalamo": "Agostinho Delalamo",
  "alto da florada": "Alto da Florada",
  "antônio modolo": "Antônio Modolo",
  "bairrinha": "Bairrinho",
  "bairrinho": "Bairrinho",
  "bairrinho i": "Bairrinho",
  "bairro bairrinha": "Bairrinho",
  "bairro bairrinho": "Bairrinho",
  "bairro da palmeirinha": "Bairro Palmeirinha",
  "bairro palmeirinha": "Bairro Palmeirinha",
  "bela vista": "Jardim Bela Vista",
  "bela vista i": "Jardim Bela Vista",
  "bela vista ii": "Jardim Bela Vista II",
  "bom jardim": "Pq. Res. Bom Jardim",
  "carolina": "Pq. Res. Carolina",
  "centro": "Centro",
  "chac. bairrinho i": "Bairrinho",
  "chac. sao joao das palmeiras": "Chácara São João das Palmeiras",
  "chacara sao joao das palmeiras": "Chácara São João das Palmeiras",
  "chacaras bairrinho": "Bairrinho",
  "chacaras bairrinho i": "Bairrinho",
  "chacaras sao joao das palmeiras": "Chácara São João das Palmeiras",
  "chác. bairrinho": "Bairrinho",
  "chác. bairrinho i": "Bairrinho",
  "chác. recanto emanuel": "Chác. Recanto Emanuel",
  "chác. são joão das palmeiras": "Chácara São João das Palmeiras",
  "chácara boa vista": "Chácara Boa Vista",
  "chácara nascente cristalina": "Chácara Nascente Cristalina",
  "chácara são joão das palmeiras": "Chácara São João das Palmeiras",
  "chácara sítio novo": "Chácara Sítio Novo",
  "chácaras bairrinho": "Bairrinho",
  "chácaras bairrinho i": "Bairrinho",
  "chácaras de recreio recanto emanuel": "Chác. Recanto Emanuel",
  "chácaras são joão das palmeiras": "Chácara São João das Palmeiras",
  "cidade jardim": "Cidade Jardim",
  "cidade jardim ii": "Cidade Jardim II",
  "cohab": "Jardim Planalto",
  "cond recanto das palmeiras": "Res. Recanto das Palmeiras",
  "cond. recanto das palmeiras": "Res. Recanto das Palmeiras",
  "condominio recanto das palmeiras": "Res. Recanto das Palmeiras",
  "condomínio recanto das palmeiras": "Res. Recanto das Palmeiras",
  "conj res recanto das palmeiras": "Res. Recanto das Palmeiras",
  "conj. res. recanto das palmeiras": "Res. Recanto das Palmeiras",
  "conjunto residencial recanto das palmeiras": "Res. Recanto das Palmeiras",
  "coração criança": "Coração Criança",
  "desm. jatobá": "Desm. Jatobá",
  "desm. josé capello": "Desm. José Capello",
  "desm. lolli": "Desm. Lolli",
  "desm. res. dos ipes": "Residencial dos Ipês",
  "desm. res. dos ipês": "Residencial dos Ipês",
  "desm. residencial dos ipes": "Residencial dos Ipês",
  "desm. residencial dos ipês": "Residencial dos Ipês",
  "desm. são miguel": "Desm. São Miguel",
  "desmembramento jatobá": "Desm. Jatobá",
  "desmembramento josé capello": "Desm. José Capello",
  "desmembramento lolli": "Desm. Lolli",
  "desmembramento são miguel": "Desm. São Miguel",
  "dona leda": "Res. Dona Leda",
  "egydio tagliari": "Egydio Tagliari",
  "estância flamboyant mirim": "Estância Flamboyant Mirim",
  "estância sol nascente": "Estância Sol Nascente",
  "faveri": "Jardim Faveri",
  "fazenda velha": "Fazenda Velha",
  "florindo caetano": "Florindo Caetano",
  "gleba a1-a": "Gleba A1-A",
  "gleba palmeiras": "Imóvel Palmeiras",
  "imovel palmeiras": "Imóvel Palmeiras",
  "imovel sao joao das palmeiras": "Chácara São João das Palmeiras",
  "imóvel denominado palmeiras": "Imóvel Palmeiras",
  "imóvel palmeiras": "Imóvel Palmeiras",
  "imóvel são joão das palmeiras": "Chácara São João das Palmeiras",
  "ipês": "Residencial dos Ipês",
  "itamaraty": "Pq. Res. Itamaraty",
  "jardim amaro": "Jardim Amaro",
  "jardim arrivabene": "Jardim Arrivabene",
  "jardim arrivabene ii": "Jardim Arrivabene II",
  "jardim arrivabene iii": "Jardim Arrivabene III",
  "jardim bela vista": "Jardim Bela Vista",
  "jardim bela vista ii": "Jardim Bela Vista II",
  "jardim blumenau": "Jardim Blumenau",
  "jardim blumenau iii": "Jardim Blumenau III",
  "jardim blumenau iv": "Jardim Blumenau IV",
  "jardim carolina": "Pq. Res. Carolina",
  "jardim conservani": "Jardim Conservani",
  "jardim da saudade": "Jardim da Saudade",
  "jardim das paineiras": "Parque das Paineiras",
  "jardim das palmeiras": "Parque das Palmeiras",
  "jardim de colores": "Jardim de Colores",
  "jardim de faveri": "Jardim Faveri",
  "jardim do lago": "Jardim do Lago",
  "jardim do trevo": "Jardim do Trevo",
  "jardim dona leda": "Res. Dona Leda",
  "jardim dos ipes": "Jardim dos Ipês",
  "jardim dos ipês": "Jardim dos Ipês",
  "jardim esperança": "Jardim Esperança",
  "jardim europa": "Jardim Europa",
  "jardim europa ii": "Jardim Europa II",
  "jardim faveri": "Jardim Faveri",
  "jardim itamaraty": "Pq. Res. Itamaraty",
  "jardim josé capello ii": "Jardim José Capello II",
  "jardim josé sampaio pires": "Jardim José Sampaio Pires",
  "jardim josé álvares carneiro": "Jardim José Álvares Carneiro",
  "jardim leonor": "Jardim Leonor",
  "jardim medeiros": "Jardim Medeiros",
  "jardim olinda": "Jardim Olinda",
  "jardim ouro branco": "Jardim Ouro Branco",
  "jardim palmeiras": "Parque das Palmeiras",
  "jardim paraíso": "Jardim Paraíso",
  "jardim planalto": "Jardim Planalto",
  "jardim planalto (cohab)": "Jardim Planalto",
  "jardim planalto ii": "Jardim Planalto II",
  "jardim planalto iii": "Jardim Planalto III",
  "jardim rezek": "Jardim Rezek I",
  "jardim rezek i": "Jardim Rezek I",
  "jardim rezek ii": "Jardim Rezek II",
  "jardim rezek iii": "Jardim Rezek III",
  "jardim rezek iv": "Jardim Rezek IV",
  "jardim ricardo duzzi": "Jardim Ricardo Duzzi",
  "jardim sacilotto": "Jardim Sacilotto I",
  "jardim sacilotto i": "Jardim Sacilotto I",
  "jardim sacilotto ii": "Jardim Sacilotto II",
  "jardim santa isabel": "Jardim Santa Isabel",
  "jardim santa rosa": "Jardim Santa Rosa",
  "jardim santo amaro": "Jardim Santo Amaro",
  "jardim são francisco": "Jardim São Francisco",
  "jardim são josé": "Jardim São José",
  "jardim vista alegre": "Jardim Vista Alegre",
  "jd bela vista": "Jardim Bela Vista",
  "jd das palmeiras": "Parque das Palmeiras",
  "jd dos ipes": "Jardim dos Ipês",
  "jd dos ipês": "Jardim dos Ipês",
  "jd palmeiras": "Parque das Palmeiras",
  "jd rezek": "Jardim Rezek I",
  "jd rezek i": "Jardim Rezek I",
  "jd rezek ii": "Jardim Rezek II",
  "jd rezek iii": "Jardim Rezek III",
  "jd rezek iv": "Jardim Rezek IV",
  "jd sacilotto": "Jardim Sacilotto I",
  "jd sacilotto i": "Jardim Sacilotto I",
  "jd sacilotto ii": "Jardim Sacilotto II",
  "jd. bela vista": "Jardim Bela Vista",
  "jd. bela vista ii": "Jardim Bela Vista II",
  "jd. das paineiras": "Parque das Paineiras",
  "jd. das palmeiras": "Parque das Palmeiras",
  "jd. de faveri": "Jardim Faveri",
  "jd. dos ipes": "Jardim dos Ipês",
  "jd. dos ipês": "Jardim dos Ipês",
  "jd. faveri": "Jardim Faveri",
  "jd. palmeiras": "Parque das Palmeiras",
  "jd. planalto": "Jardim Planalto",
  "jd. rezek": "Jardim Rezek I",
  "jd. rezek i": "Jardim Rezek I",
  "jd. rezek ii": "Jardim Rezek II",
  "jd. rezek iii": "Jardim Rezek III",
  "jd. rezek iv": "Jardim Rezek IV",
  "jd. sacilotto": "Jardim Sacilotto I",
  "jd. sacilotto i": "Jardim Sacilotto I",
  "jd. sacilotto ii": "Jardim Sacilotto II",
  "josephim tagliari": "Josephim Tagliari",
  "josé del alamo": "José Del Alamo",
  "loteamento sao joao das palmeiras": "Chácara São João das Palmeiras",
  "loteamento são joão das palmeiras": "Chácara São João das Palmeiras",
  "mário fáveri": "Res. Mário Fáveri",
  "nascente cristalina gleba b": "Nascente Cristalina Gleba B",
  "nosso sonho": "Nosso Sonho",
  "nova artur": "Nova Artur",
  "novo tempo": "Novo Tempo",
  "ouro verde": "Ouro Verde",
  "paineiras": "Parque das Paineiras",
  "palmeiras": "Parque das Palmeiras",
  "palmeirinha": "Bairro Palmeirinha",
  "parque das flores": "Parque das Flores",
  "parque das laranjeiras": "Parque das Laranjeiras",
  "parque das orquídeas ii": "Parque das Orquídeas II",
  "parque das paineiras": "Parque das Paineiras",
  "parque das palmeiras": "Parque das Palmeiras",
  "parque dos trabalhadores": "Parque dos Trabalhadores",
  "parque industrial batistela": "Pq. Ind. Batistela",
  "parque industrial itamaraty": "Pq. Ind. Itamaraty",
  "parque nosso lar": "Parque Nosso Lar",
  "parque nosso recanto": "Parque Nosso Recanto",
  "parque orlando barbosa": "Parque Orlando Barbosa",
  "parque residencial arrivabene": "Pq. Res. Arrivabene",
  "parque residencial bom jardim": "Pq. Res. Bom Jardim",
  "parque residencial carolina": "Pq. Res. Carolina",
  "parque residencial da piscina": "Pq. Res. da Piscina",
  "parque residencial das palmeiras": "Parque das Palmeiras",
  "parque residencial do horto": "Pq. Res. do Horto",
  "parque residencial humberto rossetti": "Pq. Res. Humberto Rossetti",
  "parque residencial ida sia": "Pq. Res. Ida Sia",
  "parque residencial itamaraty": "Pq. Res. Itamaraty",
  "parque residencial martinelli": "Pq. Res. Martinelli",
  "parque residencial nosso chão": "Pq. Res. Nosso Chão",
  "planalto": "Jardim Planalto",
  "planalto cohab": "Jardim Planalto",
  "planalto ii": "Jardim Planalto II",
  "planalto iii": "Jardim Planalto III",
  "portal dos manacás": "Portal dos Manacás",
  "pq das paineiras": "Parque das Paineiras",
  "pq das palmeiras": "Parque das Palmeiras",
  "pq res das palmeiras": "Parque das Palmeiras",
  "pq. bom jardim": "Pq. Res. Bom Jardim",
  "pq. das paineiras": "Parque das Paineiras",
  "pq. das palmeiras": "Parque das Palmeiras",
  "pq. ind. batistela": "Pq. Ind. Batistela",
  "pq. ind. itamaraty": "Pq. Ind. Itamaraty",
  "pq. res. arrivabene": "Pq. Res. Arrivabene",
  "pq. res. bom jardim": "Pq. Res. Bom Jardim",
  "pq. res. carolina": "Pq. Res. Carolina",
  "pq. res. da piscina": "Pq. Res. da Piscina",
  "pq. res. das palmeiras": "Parque das Palmeiras",
  "pq. res. do horto": "Pq. Res. do Horto",
  "pq. res. humberto rossetti": "Pq. Res. Humberto Rossetti",
  "pq. res. ida sia": "Pq. Res. Ida Sia",
  "pq. res. itamaraty": "Pq. Res. Itamaraty",
  "pq. res. martinelli": "Pq. Res. Martinelli",
  "pq. res. nosso chão": "Pq. Res. Nosso Chão",
  "recanto das flores": "Recanto das Flores",
  "recanto das palmeiras": "Res. Recanto das Palmeiras",
  "recanto do lar": "Recanto do Lar",
  "recanto feliz": "Recanto Feliz",
  "recanto primavera": "Recanto Primavera",
  "res dos ipes": "Residencial dos Ipês",
  "res dos ipês": "Residencial dos Ipês",
  "res recanto das palmeiras": "Res. Recanto das Palmeiras",
  "res. alto da capela": "Res. Alto da Capela",
  "res. bella laguna": "Res. Bella Laguna",
  "res. boa vista": "Res. Boa Vista",
  "res. champs elisée": "Res. Champs Elisée",
  "res. conquista": "Res. Conquista",
  "res. conquista ii": "Res. Conquista II",
  "res. da torre": "Res. da Torre",
  "res. das orquídeas": "Res. das Orquídeas",
  "res. do bosque": "Res. do Bosque",
  "res. dona leda": "Res. Dona Leda",
  "res. dos ipes": "Residencial dos Ipês",
  "res. dos ipês": "Residencial dos Ipês",
  "res. jardim do sol": "Res. Jardim do Sol",
  "res. manhattan": "Res. Manhattan",
  "res. mário fáveri": "Res. Mário Fáveri",
  "res. nova conquista": "Res. Nova Conquista",
  "res. parque imperial": "Res. Parque Imperial",
  "res. recanto das palmeiras": "Res. Recanto das Palmeiras",
  "res. san marino": "Res. San Marino",
  "res. sete chácaras": "Res. Sete Chácaras",
  "res. são joão dos pinheiros": "Res. São João dos Pinheiros",
  "res. são luiz": "Res. São Luiz",
  "res. villa nogueira": "Res. Villa Nogueira",
  "residencial alto da capela": "Res. Alto da Capela",
  "residencial bela vista": "Jardim Bela Vista",
  "residencial bella laguna": "Res. Bella Laguna",
  "residencial boa vista": "Res. Boa Vista",
  "residencial champs elisée": "Res. Champs Elisée",
  "residencial conquista": "Res. Conquista",
  "residencial conquista ii": "Res. Conquista II",
  "residencial da torre": "Res. da Torre",
  "residencial das orquídeas": "Res. das Orquídeas",
  "residencial do bosque": "Res. do Bosque",
  "residencial dona leda": "Res. Dona Leda",
  "residencial dos ipes": "Residencial dos Ipês",
  "residencial dos ipês": "Residencial dos Ipês",
  "residencial jardim do sol": "Res. Jardim do Sol",
  "residencial manhattan": "Res. Manhattan",
  "residencial mario faveri": "Res. Mário Fáveri",
  "residencial mário fáveri": "Res. Mário Fáveri",
  "residencial nova conquista": "Res. Nova Conquista",
  "residencial parque imperial": "Res. Parque Imperial",
  "residencial recanto das palmeiras": "Res. Recanto das Palmeiras",
  "residencial san marino": "Res. San Marino",
  "residencial sao joao dos pinheiros": "Res. São João dos Pinheiros",
  "residencial sete chácaras": "Res. Sete Chácaras",
  "residencial são joão dos pinheiros": "Res. São João dos Pinheiros",
  "residencial são luiz": "Res. São Luiz",
  "residencial villa nogueira": "Res. Villa Nogueira",
  "rezek": "Jardim Rezek I",
  "rezek 1": "Jardim Rezek I",
  "rezek 2": "Jardim Rezek II",
  "rezek 3": "Jardim Rezek III",
  "rezek 4": "Jardim Rezek IV",
  "rezek i": "Jardim Rezek I",
  "rezek ii": "Jardim Rezek II",
  "rezek iii": "Jardim Rezek III",
  "rezek iv": "Jardim Rezek IV",
  "rota das flores": "Rota das Flores",
  "sacilotto": "Jardim Sacilotto I",
  "sacilotto 1": "Jardim Sacilotto I",
  "sacilotto 2": "Jardim Sacilotto II",
  "sacilotto i": "Jardim Sacilotto I",
  "sacilotto ii": "Jardim Sacilotto II",
  "santa rita de cássia": "Santa Rita de Cássia",
  "santo antonio": "Santo Antonio",
  "sao joao": "São João",
  "sao joao das palmeiras": "Chácara São João das Palmeiras",
  "sao joao dos pinheiros": "Res. São João dos Pinheiros",
  "sao vicente": "Vila São Vicente",
  "são joão": "São João",
  "são joão das palmeiras": "Chácara São João das Palmeiras",
  "são joão dos pinheiros": "Res. São João dos Pinheiros",
  "são vicente": "Vila São Vicente",
  "vila nogueira": "Res. Villa Nogueira",
  "vila queiroz": "Vila Queiroz",
  "vila rodrigues": "Vila Rodrigues",
  "vila sao vicente": "Vila São Vicente",
  "vila são vicente": "Vila São Vicente",
  "villa nogueira": "Res. Villa Nogueira",
  "wada": "Wada",
};

export const BAIRRO_SEARCH_SPECS = {
  "Jardim Sacilotto I": {
    positive: [
      "Jardim Sacilotto I",
      "Sacilotto I",
      "Sacilotto 1",
      "Jd. Sacilotto I",
      "Jd Sacilotto I",
      "Jardim Sacilotto",
      "Jd. Sacilotto",
      "Sacilotto",
    ],
    negative: ["Sacilotto II", "Sacilotto 2", "Sacilotto III", "Sacilotto 3"],
  },
  "Jardim Sacilotto II": {
    positive: [
      "Jardim Sacilotto II",
      "Sacilotto II",
      "Sacilotto 2",
      "Jd. Sacilotto II",
      "Jd Sacilotto II",
    ],
    negative: ["Sacilotto I", "Sacilotto 1"],
  },
  "Bairrinho": {
    positive: [
      "Bairrinho",
      "Bairrinha",
      "Chácaras Bairrinho",
      "Chacaras Bairrinho",
      "Chác. Bairrinho",
      "Chac. Bairrinho",
    ],
    negative: [],
  },
  "Jardim Rezek I": {
    positive: [
      "Jardim Rezek I",
      "Jardim Rezek",
      "Rezek I",
      "Rezek 1",
      "Jd. Rezek I",
      "Jd Rezek I",
      "Jd. Rezek",
      "Jd Rezek",
      "Rezek",
    ],
    negative: [
      "Rezek II",
      "Rezek 2",
      "Rezek III",
      "Rezek 3",
      "Rezek IV",
      "Rezek 4",
      "Jorge Rezek",
    ],
  },
  "Jardim Rezek II": {
    positive: [
      "Jardim Rezek II",
      "Rezek II",
      "Rezek 2",
      "Jd. Rezek II",
      "Jd Rezek II",
    ],
    negative: [
      "Rezek I",
      "Rezek 1",
      "Rezek III",
      "Rezek 3",
      "Rezek IV",
      "Rezek 4",
    ],
  },
  "Jardim Rezek III": {
    positive: [
      "Jardim Rezek III",
      "Rezek III",
      "Rezek 3",
      "Jd. Rezek III",
      "Jd Rezek III",
    ],
    negative: [
      "Rezek I",
      "Rezek 1",
      "Rezek II",
      "Rezek 2",
      "Rezek IV",
      "Rezek 4",
    ],
  },
  "Jardim Rezek IV": {
    positive: [
      "Jardim Rezek IV",
      "Rezek IV",
      "Rezek 4",
      "Jd. Rezek IV",
      "Jd Rezek IV",
    ],
    negative: [
      "Rezek I",
      "Rezek 1",
      "Rezek II",
      "Rezek 2",
      "Rezek III",
      "Rezek 3",
    ],
  },
  "Residencial dos Ipês": {
    positive: [
      "Residencial dos Ipês",
      "Residencial dos Ipes",
      "Res. dos Ipês",
      "Res. dos Ipes",
      "Desm. Res. dos Ipês",
      "Desm. Res. dos Ipes",
      "Desm. Residencial dos Ipês",
      "Desm. Residencial dos Ipes",
    ],
    negative: ["Jardim dos Ipês", "Jardim dos Ipes", "Jd. dos Ipês", "Jd. dos Ipes"],
  },
  "Jardim dos Ipês": {
    positive: [
      "Jardim dos Ipês",
      "Jardim dos Ipes",
      "Jd. dos Ipês",
      "Jd. dos Ipes",
      "Jd dos Ipês",
      "Jd dos Ipes",
    ],
    negative: [
      "Residencial dos Ipês",
      "Residencial dos Ipes",
      "Res. dos Ipês",
      "Desm. Res. dos Ipês",
    ],
  },
  "Jardim Bela Vista": {
    positive: [
      "Jardim Bela Vista",
      "Bela Vista",
      "Bela Vista I",
      "Residencial Bela Vista",
      "Jd. Bela Vista",
    ],
    negative: ["Bela Vista II", "Bela Vista 2"],
  },
  "Jardim Bela Vista II": {
    positive: [
      "Jardim Bela Vista II",
      "Bela Vista II",
      "Bela Vista 2",
      "Jd. Bela Vista II",
    ],
    negative: ["Bela Vista I", "Bela Vista 1"],
  },
  "Jardim Planalto": {
    positive: [
      "Jardim Planalto",
      "Planalto",
      "Planalto (COHAB)",
      "Planalto COHAB",
      "Jd. Planalto",
    ],
    negative: ["Planalto II", "Planalto 2", "Planalto III", "Planalto 3"],
  },
  "Jardim Planalto II": {
    positive: [
      "Jardim Planalto II",
      "Planalto II",
      "Planalto 2",
      "Jd. Planalto II",
    ],
    negative: ["Planalto I", "Planalto 1", "Planalto III", "Planalto 3"],
  },
  "Jardim Planalto III": {
    positive: [
      "Jardim Planalto III",
      "Planalto III",
      "Planalto 3",
      "Jd. Planalto III",
    ],
    negative: ["Planalto I", "Planalto 1", "Planalto II", "Planalto 2"],
  },
  "Jardim Faveri": {
    positive: [
      "Jardim Faveri",
      "Jardim de Faveri",
      "Jd. Faveri",
      "Jd. de Faveri",
      "Faveri",
    ],
    negative: ["Mário Fáveri", "Mario Faveri"],
  },
  "Res. Mário Fáveri": {
    positive: [
      "Mário Fáveri",
      "Mario Faveri",
      "Residencial Mário Fáveri",
      "Res. Mário Fáveri",
    ],
    negative: [],
  },
  "Pq. Res. Itamaraty": {
    positive: [
      "Parque Residencial Itamaraty",
      "Pq. Res. Itamaraty",
      "Jardim Itamaraty",
      "Itamaraty",
    ],
    negative: ["Parque Industrial Itamaraty", "Pq. Ind. Itamaraty", "Industrial Itamaraty"],
  },
  "Pq. Ind. Itamaraty": {
    positive: [
      "Parque Industrial Itamaraty",
      "Pq. Ind. Itamaraty",
      "Industrial Itamaraty",
    ],
    negative: ["Parque Residencial Itamaraty", "Residencial Itamaraty"],
  },
};

/**
 * Retorna o nome canônico oficial de um bairro, resolvendo grafias duplicadas e apelidos.
 *
 * @param {string} [name]
 * @returns {string}
 */
const LOWERCASE_PARTICLES = new Set([
  "de",
  "da",
  "do",
  "das",
  "dos",
  "e",
  "em",
  "na",
  "no",
  "nas",
  "nos",
]);

const ROMAN_NUMERALS_REGEX = /^(i{1,3}|iv|v|vi{1,3}|ix|x)$/i;

const ABBREVIATIONS_MAP = {
  "jd.": "Jd.",
  "pq.": "Pq.",
  "res.": "Res.",
  "chác.": "Chác.",
  "chac.": "Chác.",
  "desm.": "Desm.",
  "cond.": "Cond.",
  "conj.": "Conj.",
  "ind.": "Ind.",
  "cohab": "COHAB",
  "(cohab)": "(COHAB)",
  "sp": "SP",
  "cdhu": "CDHU",
};

/**
 * Converte e padroniza a capitalização do nome do bairro para o padrão formal (Title Case / Aa).
 * Preserva algarismos romanos em caixa alta, conectivos em minúsculas e abreviações oficiais.
 *
 * @param {string} [name]
 * @returns {string}
 */
export function formatBairroName(name) {
  if (!name || typeof name !== "string") return "";
  const clean = name
    .replace(/^\d+\s*-\s*/, "")
    .replace(/\s+/g, " ")
    .trim();
  if (!clean) return "";

  const words = clean.split(" ");
  const formattedWords = words.map((word, index) => {
    const lower = word.toLowerCase();

    // 1. Abreviaturas conhecidas
    if (ABBREVIATIONS_MAP[lower]) {
      return ABBREVIATIONS_MAP[lower];
    }

    // 2. Numerais romanos (I, II, III, IV, etc.)
    if (ROMAN_NUMERALS_REGEX.test(lower)) {
      return lower.toUpperCase();
    }

    // 3. Conectivos e preposições (em minúscula se não for a primeira palavra)
    if (index > 0 && LOWERCASE_PARTICLES.has(lower)) {
      return lower;
    }

    // 4. Palavras compostas por hífen (ex: 'A1-A' ou 'Alto-da-Boa-Vista')
    if (word.includes("-")) {
      const parts = word.split("-");
      const formattedParts = parts.map((part, pIdx) => {
        const pLower = part.toLowerCase();
        if (
          ROMAN_NUMERALS_REGEX.test(pLower) ||
          (part.length <= 2 && /^[a-z0-9]+$/i.test(part) && /\d/.test(part))
        ) {
          return part.toUpperCase();
        }
        if (pIdx > 0 && LOWERCASE_PARTICLES.has(pLower)) {
          return pLower;
        }
        return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
      });
      return formattedParts.join("-");
    }

    // 5. Parênteses (ex: '(COHAB)')
    if (word.startsWith("(") && word.endsWith(")")) {
      const inner = word.slice(1, -1).toLowerCase();
      if (ABBREVIATIONS_MAP[inner]) {
        return `(${ABBREVIATIONS_MAP[inner]})`;
      }
      if (ROMAN_NUMERALS_REGEX.test(inner)) {
        return `(${inner.toUpperCase()})`;
      }
      return `(${inner.charAt(0).toUpperCase() + inner.slice(1).toLowerCase()})`;
    }

    // 6. Capitalização padrão Title Case ("Aa") respeitando caracteres acentuados
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  });

  return formattedWords.join(" ");
}

/**
 * Retorna o nome canônico oficial de um bairro, resolvendo grafias duplicadas, apelidos
 * e padronizando a capitalização formal em Title Case (Aa).
 *
 * @param {string} [name]
 * @returns {string}
 */
export function canonicalizeBairro(name) {
  if (!name || typeof name !== "string" || !name.trim()) return "";
  const clean = name
    .replace(/^\d+\s*-\s*/, "")
    .replace(/\s+/g, " ")
    .trim();
  const key = clean.toLowerCase();
  return CANONICAL_BAIRRO_MAP[key] || formatBairroName(clean);
}


export function getRomanPhase(str) {
  if (!str) return null;
  const m = String(str).match(/\b(i{1,3}|iv|v|vi|[1-5])\b/i);
  return m ? m[1].toUpperCase() : null;
}

/**
 * Retorna os termos de busca positiva e termos proibidos (negativos) para o bairro.
 *
 * @param {string} bairroInput
 * @returns {{ canonical: string, positive: string[], negative: string[] }}
 */
export function getBairroSearchTerms(bairroInput) {
  if (!bairroInput || !bairroInput.trim()) {
    return { canonical: "", positive: [], negative: [] };
  }

  const raw = bairroInput.trim();
  const canonical = canonicalizeBairro(raw);

  if (BAIRRO_SEARCH_SPECS[canonical]) {
    return {
      canonical,
      positive: BAIRRO_SEARCH_SPECS[canonical].positive,
      negative: BAIRRO_SEARCH_SPECS[canonical].negative,
    };
  }

  const positive = [canonical, raw];
  const negative = [];

  const phase = getRomanPhase(canonical);
  if (phase) {
    const baseName = canonical.replace(/\b(i{1,3}|iv|v|vi|[1-5])\b/i, "").trim();
    const allPhases = ["I", "II", "III", "IV", "V", "1", "2", "3", "4", "5"];
    allPhases.forEach((p) => {
      if (p !== phase) negative.push(`${baseName} ${p}`);
    });
  } else {
    const core = canonical
      .replace(
        /^(jardim|jd\.?|pq\.?|parque|res\.?|residencial|chác\.?|chácara|bairro|conj\.?)\s+(de\s+|da\s+|do\s+|dos\s+|das\s+|res\.?\s+|ind\.?\s+)?/i,
        ""
      )
      .trim();
    if (core && core.length >= 4 && core.toLowerCase() !== canonical.toLowerCase()) {
      positive.push(core);
    }
  }

  // Deduplica preservando ordem
  const seen = new Set();
  const dedupPositive = [];
  positive.forEach((t) => {
    const clean = t.trim();
    if (clean && !seen.has(clean.toLowerCase())) {
      seen.add(clean.toLowerCase());
      dedupPositive.push(clean);
    }
  });

  return { canonical, positive: dedupPositive, negative };
}

/**
 * Compara dois nomes de bairro para determinar se referem-se à mesma área física.
 *
 * @param {string} a
 * @param {string} b
 * @returns {boolean}
 */
export function areSameNeighborhood(a, b) {
  if (!a || !b) return false;
  const canA = canonicalizeBairro(a).toLowerCase();
  const canB = canonicalizeBairro(b).toLowerCase();
  if (canA === canB) return true;

  const phaseA = getRomanPhase(canA);
  const phaseB = getRomanPhase(canB);
  if (phaseA || phaseB) {
    if (phaseA !== phaseB) return false;
  }

  return false;
}
